var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.782 11.107a4.6 4.6 0 0 0-3.1 4.63l.048.787-.8-.1a12.93 12.93 0 0 1-7.57-3.73l-1.046-1.041-.269.771a4.65 4.65 0 0 0 .986 4.76c.636.675.493.771-.6.37-.234-.11-.488-.17-.747-.176a5.77 5.77 0 0 0 .572 2.155 5.14 5.14 0 0 0 2.179 2.059l.78.37-.924.014c-.89 0-.923.016-.826.355a4.81 4.81 0 0 0 2.974 2.638l.986.338-.859.515a8.9 8.9 0 0 1-4.267 1.188 4.69 4.69 0 0 0-1.3.128c.952.612 1.985 1.088 3.069 1.415a13.42 13.42 0 0 0 10.431-1.19c2.35-1.504 4.196-3.678 5.3-6.24.599-1.545.964-3.17 1.081-4.823 0-.74.047-.836.938-1.72a10.7 10.7 0 0 0 1.114-1.237c.16-.306.142-.306-.668-.033-1.351.483-1.542.419-.874-.305.482-.488.851-1.075 1.081-1.72 0-.047-.239.033-.509.176-.45.222-.918.405-1.4.546l-.863.271-.779-.533c-.421-.288-.874-.526-1.351-.708a5.43 5.43 0 0 0-2.787.07z",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.3ca5ae13aae205703f39b3fd5f142314.svg";
export { ForwardRef as ReactComponent };